import React from "react";
import Card from "./Card";
import SettingStore from "stores/settings";
import {
  PROP_TYPE_PROGRAM_CONTENT,
  PROP_DEFAULT_PROGRAM_CONTENT,
} from "../../../propTypes";
import * as CONSTANTS from "../../../constants";
import styled from "styled-components";
import { Box } from "Components/Base/Layout/Box";

const StyledProgramCard = styled.span`
  .MuiBox-root {
    width: 300px !important;
  }

  .MuiCardActionArea-root {
    height: 30% !important;
  }

  .MuiCard-root {
    height: 250px;
  }

  .MuiCardContent-root {
    padding: 0 16px !important;
  }

  .MuiCard-root button {
    max-height: 26px;
  }
`;

const ProgramCards = (props) => {
  const {
    steps,
    activityId,
    onRefresh,
    programParticipant,
    isPreview,
    isManager,
  } = props;
  const displayCardImage =
    SettingStore.getSettingValue(
      CONSTANTS.SYSTEM_SETTING_SHOW_COURSE_IMAGE_PORTAL,
    ) === CONSTANTS.SYSTEM_SETTING_ON;

  return (
    <div
      className="program-cards flex flex-wrap"
      initial="hidden"
      animate="visible"
    >
      {steps.map((course, index) => {
        course.index = index;

        return (
          <StyledProgramCard>
            <Box my={4} mx={2}>
              <Card
                course={course}
                order={index}
                displayImage={displayCardImage}
                activityId={activityId}
                onRefresh={onRefresh}
                programParticipant={programParticipant}
                isPreview={isPreview}
                isManager={isManager}
              />
            </Box>
          </StyledProgramCard>
        );
      })}
    </div>
  );
};

ProgramCards.propTypes = {
  steps: PROP_TYPE_PROGRAM_CONTENT,
};

ProgramCards.defaultProps = {
  steps: PROP_DEFAULT_PROGRAM_CONTENT,
};

export default ProgramCards;
